import script from "./Sidenav.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidenav.vue?vue&type=script&setup=true&lang=js"

import "./Sidenav.vue?vue&type=style&index=0&id=4f6c852a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f6c852a"]])

export default __exports__